var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      staticClass: "showHeader",
      attrs: {
        visible: _vm.drawerVisible,
        wrapperClosable: false,
        direction: "rtl",
        size: "1000px",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawerVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "demo-drawer_title",
          attrs: { slot: "title" },
          slot: "title",
        },
        [_vm._v("权益说明")]
      ),
      _c(
        "div",
        { staticClass: "detailSection" },
        [
          _c(
            "el-form",
            {
              ref: "pram",
              staticClass: "demo-ruleForm px35",
              attrs: { model: _vm.pram, "label-width": "75px" },
            },
            [
              _c("el-form-item", { attrs: { label: "权益名称：" } }, [
                _c(
                  "div",
                  {
                    staticClass: "from-ipt-width el-input el-input--small",
                    attrs: { disabled: "" },
                  },
                  [
                    _c("span", { staticClass: "el-input__inner" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("filterMemberBenefits")(_vm.pram.name)
                          ) +
                          " "
                      ),
                    ]),
                  ]
                ),
              ]),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "权益说明：",
                    prop: "expand",
                    rules: [
                      {
                        required: true,
                        message: "请填写权益说明",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("Tinymce", {
                    model: {
                      value: _vm.pram.expand,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.pram,
                          "expand",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "pram.expand",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _vm.checkPermi([
                    "platform:paid:member:benefits:statement:edit",
                  ])
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "debounceClick",
                              rawName: "v-debounceClick",
                              value: _vm.submitForm,
                              expression: "submitForm",
                            },
                          ],
                          attrs: { type: "primary" },
                        },
                        [_vm._v("提交")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }